import { render, staticRenderFns } from "./Kucsc.vue?vue&type=template&id=998a2042&scoped=true&"
import script from "./Kucsc.vue?vue&type=script&lang=js&"
export * from "./Kucsc.vue?vue&type=script&lang=js&"
import style0 from "./Kucsc.vue?vue&type=style&index=0&id=998a2042&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "998a2042",
  null
  
)

export default component.exports